// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "Content/" + chunkId + "-" + "daac9c32834ddf9a1b61" + ".css";
};